export const RECEIVE_FIRM_FOLDERS = 'RECEIVE_FIRM_FOLDERS';
export const REQUEST_FIRM_FOLDERS = 'REQUEST_FIRM_FOLDERS';
export const REQUEST_FIRM_USERS = 'REQUEST_FIRM_USERS';
export const RECEIVE_FIRM_USERS = 'RECEIVE_FIRM_USERS';